import {apiAutocomplete} from '../enumerator/api-autocomplete.enum';

/**
 * -----------------
 * RestfulApiService
 * -----------------
 * gère les requêtes à l'api
 * */
export default class RestfulApiService {

    /**
     * -------------------
     * search_address
     * -------------------
     * Permet de récupérer un tableau de suggestion d'adresse selon une chaine de caractère ou des coordonées
     */
    static searchAddress(query) {
        query = query.replace(/\ /g, apiAutocomplete.AUTOCOMPLETE_SPACE.space);
        return $.get(apiAutocomplete.GET_AUTOCOMPLETE.url.replace('{query}', query));
    }

    /**
     * -------------------
     * reverse_address
     * -------------------
     * Permet de récupérer un tableau de suggestion d'adresse selon des coordonées
     */
    static reverseAddress(longitude, latitude) {
        return $.get(apiAutocomplete.GET_AUTOCOMPLETE.url.replace('{query}', `${latitude},${longitude}`));
    }

    /**
     * -------------------
     * createPostRequest
     * -------------------
     * Créer une requête http selon la méthode spécifier
     */
    static createRequest(method, uri, body, options) {
        if (!!body) {
            if (!options) {
                options = {};
            }
            options.body = body;
        }
        return $.request(method, uri, options).toPromise();
    }
}
